import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AppContainer } from '@/components/AppContainer/AppContainer';

// Динамические импорты страниц
const RafflePage = lazy(() => import('@/pages/Raffle/RafflePage').then(module => ({ default: module.RafflePage })));
const DetailedGiveawayPage = lazy(() => import('@/pages/Raffle/DetailedGiveawayComponents/DetailedGiveawayPage').then(module => ({ default: module.default })));
const TasksPage = lazy(() => import('@/pages/Tasks/TasksPage').then(module => ({ default: module.default })));
const ReferalsPage = lazy(() => import('@/pages/Referals/ReferalsPage').then(module => ({ default: module.default })));
const DonatePage = lazy(() => import('@/pages/Donate/DonatePage').then(module => ({ default: module.default })));

// Компонент загрузки для Suspense
const PageLoader = () => (
  <AppContainer>
    <div>Загрузка...</div>
  </AppContainer>
);

export const AppRouter = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<RafflePage />} />
        <Route path="/giveaway/:id" element={<DetailedGiveawayPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/referals" element={<ReferalsPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
